import { Grid, Box, Container } from "@mui/material";
import { AboutContentText, AboutContentImage } from "@/components/ui";

export const AboutContent = () => {
  return (
    <Container maxWidth="lg">
      <Box>
        <Grid container spacing={6} sx={{ py: 8, alignItems: "flex-start" }}>
          <Grid size={{ xs: 12, md: 6 }} sx={{ display: "flex", alignItems: "flex-start" }}>
            <AboutContentText />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }} sx={{ display: "flex", alignItems: "flex-start" }}>
            <AboutContentImage />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};
